import styled from '@emotion/styled'

export const DisabledItemWithTooltipWrapper = styled.div`
  width: 100%;
`

export const DisabledItemWithTooltipContent = styled.div`
  display: flex;
  opacity: 0.5;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  cursor: not-allowed;
`
